import { AtmPaymentInfo } from '@cart-ui/PaymentInfo/AtmPaymentInfo'
import { CvsPaymentInfo } from '@cart-ui/PaymentInfo/CvsPaymentInfo'
import { PayMePaymentInfo } from '@cart-ui/PaymentInfo/PayMePaymentInfo'
import { type FpPaymentInfo } from '@hooks-api/types/dataModel/fpOrder'
import { PaymentMethodMap, PaymentMethodType } from '@hooks-api/types/dataModel/payment'
import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { useTranslation } from 'react-i18next'

const styles = stylex.create({
  info: {
    display: 'grid',
    gridTemplateColumns: '1fr 3fr',
  },
})

interface PaymentInfoProps {
  paymentMethod?: PaymentMethodType
  needPdf?: boolean
  postingDateInNextMonth?: boolean
  paymentInfo?: FpPaymentInfo | null
  rootStyle?: stylex.StyleXStyles
  shouldShowPdf?: boolean
}

export const OrderPaymentInfo = ({ paymentMethod, needPdf, postingDateInNextMonth, paymentInfo, rootStyle, shouldShowPdf }: PaymentInfoProps) => {
  const { t } = useTranslation()
  const isAtmPayment = paymentMethod === PaymentMethodType.ATM
  const isCvsPayment = paymentMethod === PaymentMethodType.CVS
  const isPayMePayment = paymentMethod === PaymentMethodType.PAYME
  return (
    <VStack rootStyle={rootStyle}>
      <Text variant="subtitle">{t('orderDetail.paymentInfo', { defaultValue: '付款資訊' })}</Text>
      <Box rootStyle={styles.info}>
        <Text variant="body" color={colors.grey600}>{t('orderDetail.paymentMethod', { defaultValue: '付款方式' })}</Text>
        <VStack gap={1}>
          <Text variant="body">{paymentMethod ? t(`payment.${paymentMethod}`, { defaultValue: PaymentMethodMap[paymentMethod] }) : '-'}</Text>
          <HStack>
            {
              needPdf && shouldShowPdf
              && <Text variant="body" color={colors.grey500}>{t('orderDetail.invoiceAttachment', { defaultValue: '附上訂單明細 (PDF INV)' })}</Text>
            }
            {
              needPdf && postingDateInNextMonth
              && <Text variant="body" color={colors.grey500}>{', '}</Text>
            }
            {
              postingDateInNextMonth
              && <Text variant="body" color={colors.grey500}>{t('orderDetail.crossMonthBilling', { defaultValue: '跨月帳款' })}</Text>
            }
          </HStack>
        </VStack>
      </Box>
      {isAtmPayment && <AtmPaymentInfo paymentInfo={paymentInfo} />}
      {isCvsPayment && <CvsPaymentInfo paymentInfo={paymentInfo} />}
      {isPayMePayment && paymentInfo?.web_link && <PayMePaymentInfo url={paymentInfo?.web_link} />}
    </VStack>
  )
}
